module.exports = __webpack_public_path__ + "static/beigebooties-e744d093b28a7baab1849b5a9747c065.jpeg";